import { render, staticRenderFns } from "./SummaryRoomDimensions.vue?vue&type=template&id=38ca3368&scoped=true&"
import script from "./SummaryRoomDimensions.vue?vue&type=script&lang=ts&"
export * from "./SummaryRoomDimensions.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryRoomDimensions.vue?vue&type=style&index=0&id=38ca3368&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ca3368",
  null
  
)

export default component.exports